module.exports = __webpack_public_path__ + "img/service-02-img1.672ffe81.png";